import React, { useState, useEffect } from 'react';
import { useSubmissions } from '../SubmissionsContext';

// Full-screen photo lightbox
function Lightbox({ photos, startIndex, onClose }) {
  const [idx, setIdx] = useState(startIndex);
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 2000,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <button onClick={onClose} style={{
        position: 'absolute', top: '16px', right: '16px', background: 'rgba(255,255,255,0.15)',
        border: 'none', color: '#fff', width: '36px', height: '36px', borderRadius: '50%', fontSize: '18px', cursor: 'pointer',
      }}>✕</button>

      <img
        src={photos[idx].url}
        alt=""
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '95vw', maxHeight: '80vh', objectFit: 'contain', borderRadius: '8px' }}
      />

      {photos.length > 1 && (
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }} onClick={e => e.stopPropagation()}>
          <button
            onClick={() => setIdx(i => (i - 1 + photos.length) % photos.length)}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: '40px', height: '40px', borderRadius: '50%', fontSize: '20px', cursor: 'pointer' }}
          >‹</button>
          <span style={{ color: '#fff', lineHeight: '40px', fontSize: '13px' }}>{idx + 1} / {photos.length}</span>
          <button
            onClick={() => setIdx(i => (i + 1) % photos.length)}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: '40px', height: '40px', borderRadius: '50%', fontSize: '20px', cursor: 'pointer' }}
          >›</button>
        </div>
      )}

      <a
        href={photos[idx].url}
        download={`care-moment-photo-${idx + 1}.jpg`}
        onClick={e => e.stopPropagation()}
        style={{
          marginTop: '12px', color: 'rgba(255,255,255,0.6)', fontSize: '12px',
          textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px',
        }}
      >
        ⬇ Download this photo
      </a>
    </div>
  );
}

const s = {
  page: { padding: '16px 16px 24px', maxWidth: '540px', margin: '0 auto' },
  heading: { fontSize: '20px', fontWeight: '700', color: '#222', marginBottom: '4px' },
  sub: { fontSize: '13px', color: '#888', marginBottom: '20px' },
  card: {
    background: '#fff', borderRadius: '12px', padding: '16px',
    marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    borderLeft: '4px solid #e0e0e0',
  },
  cardPending: { borderLeft: '4px solid #fb8c00' },
  cardApproved: { borderLeft: '4px solid #2e7d32' },
  cardDeclined: { borderLeft: '4px solid #e53935' },
  topRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' },
  about: { fontSize: '15px', fontWeight: '700', color: '#222' },
  status: { display: 'inline-block', padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' },
  statusPending: { background: '#fff3e0', color: '#e65100' },
  statusApproved: { background: '#e8f5e9', color: '#2e7d32' },
  statusDeclined: { background: '#fce4ec', color: '#c62828' },
  meta: { fontSize: '12px', color: '#aaa', marginBottom: '8px' },
  caption: { fontSize: '13px', color: '#555', lineHeight: '1.55', marginBottom: '10px' },
  declineReason: {
    background: '#fff3e0', border: '1px solid #ffe0b2', borderRadius: '6px',
    padding: '8px 10px', fontSize: '12px', color: '#e65100', marginBottom: '10px',
  },
  photoStrip: { display: 'flex', gap: '6px', marginBottom: '12px', overflowX: 'auto' },
  photoThumb: { width: '90px', height: '90px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0, cursor: 'pointer', border: '2px solid transparent' },
  photoThumbHover: { border: '2px solid #DB3267' },
  bottomRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  catBadge: { background: '#f3e5f5', color: '#6a1b9a', borderRadius: '20px', padding: '2px 10px', fontSize: '11px', fontWeight: '600' },
  deleteBtn: {
    background: 'none', border: '1px solid #ffcdd2', color: '#e53935',
    borderRadius: '6px', padding: '4px 10px', fontSize: '12px', cursor: 'pointer',
  },
  editBtn: {
    background: 'none', border: '1px solid #e0e0e0', color: '#555',
    borderRadius: '6px', padding: '4px 10px', fontSize: '12px', cursor: 'pointer',
  },
  editWindow: { fontSize: '11px', color: '#bbb', marginBottom: '8px' },
  editForm: { borderTop: '1px solid #f0f0f0', marginTop: '10px', paddingTop: '12px' },
  editInput: { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', fontSize: '13px', outline: 'none', boxSizing: 'border-box', marginBottom: '8px' },
  editTextarea: { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', fontSize: '13px', outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', marginBottom: '8px' },
  editActions: { display: 'flex', gap: '8px' },
  editSaveBtn: { padding: '8px 16px', background: '#DB3267', color: '#fff', borderRadius: '8px', fontSize: '13px', fontWeight: '700', border: 'none', cursor: 'pointer' },
  editCancelBtn: { padding: '8px 12px', background: '#f5f4f8', color: '#888', borderRadius: '8px', fontSize: '13px', fontWeight: '600', border: 'none', cursor: 'pointer' },
  editError: { fontSize: '12px', color: '#e53935', marginBottom: '6px' },
  confirmOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
  },
  confirmBox: {
    background: '#fff', borderRadius: '12px', padding: '24px', maxWidth: '320px',
    width: '100%', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  confirmTitle: { fontSize: '16px', fontWeight: '700', marginBottom: '8px' },
  confirmText: { fontSize: '13px', color: '#666', marginBottom: '20px', lineHeight: '1.5' },
  confirmBtns: { display: 'flex', gap: '10px' },
  confirmDelete: { flex: 1, padding: '11px', background: '#e53935', color: '#fff', borderRadius: '8px', fontWeight: '700', fontSize: '14px' },
  confirmCancel: { flex: 1, padding: '11px', background: '#f5f5f5', color: '#555', borderRadius: '8px', fontWeight: '600', fontSize: '14px' },
  empty: { textAlign: 'center', padding: '60px 20px', color: '#bbb' },
  emptyIcon: { fontSize: '48px', marginBottom: '12px' },
  winnerBadge: {
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    background: '#fff8e1', color: '#f57f17', borderRadius: '20px',
    padding: '2px 10px', fontSize: '11px', fontWeight: '700', marginBottom: '8px',
  },
};

function EditableCard({ sub, onSaved }) {
  const { editSubmission } = useSubmissions();
  const [editing, setEditing]   = useState(false);
  const [about, setAbout]       = useState(sub.about);
  const [caption, setCaption]   = useState(sub.caption);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [minsLeft, setMinsLeft] = useState(null);

  useEffect(() => {
    const submittedMs = new Date(sub.submittedAt.replace(' ', 'T') + '+00:00').getTime();
    const tick = () => {
      const left = 30 - Math.floor((Date.now() - submittedMs) / 60000);
      setMinsLeft(left);
    };
    tick();
    const t = setInterval(tick, 10000);
    return () => clearInterval(t);
  }, [sub.submittedAt]);

  async function save() {
    if (!about.trim() || !caption.trim()) return;
    setSaving(true);
    setError('');
    const res = await editSubmission(sub.id, about.trim(), caption.trim());
    setSaving(false);
    if (res.ok) { setEditing(false); onSaved && onSaved(); }
    else setError(res.error || 'Failed to save.');
  }

  if (!editing) return (
    <>
      {minsLeft !== null && minsLeft > 0 && (
        <div style={s.editWindow}>Edit window: {minsLeft} min{minsLeft !== 1 ? 's' : ''} remaining</div>
      )}
    </>
  );

  return (
    <div style={s.editForm}>
      {error && <div style={s.editError}>{error}</div>}
      <input style={s.editInput} value={about} onChange={e => setAbout(e.target.value)} placeholder="About..." />
      <textarea style={s.editTextarea} rows={4} value={caption} onChange={e => setCaption(e.target.value)} placeholder="Caption..." />
      <div style={s.editActions}>
        <button style={s.editSaveBtn} onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button>
        <button style={s.editCancelBtn} onClick={() => { setEditing(false); setAbout(sub.about); setCaption(sub.caption); }}>Cancel</button>
      </div>
    </div>
  );
}

export default function MySubmissions({ user }) {
  const { submissions, softDelete, winner } = useSubmissions();
  const [confirmId, setConfirmId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [lightbox, setLightbox] = useState(null); // { photos, index }

  const mine = submissions.filter(s => s.submittedBy === user.name && !s.deletedByUser);

  async function handleDelete(id) {
    await softDelete(id, user.name);
    setConfirmId(null);
  }

  const statusStyle = (status) => {
    if (status === 'approved') return { ...s.status, ...s.statusApproved };
    if (status === 'declined') return { ...s.status, ...s.statusDeclined };
    return { ...s.status, ...s.statusPending };
  };

  const statusLabel = (status) => {
    if (status === 'approved') return '✓ Shared';
    if (status === 'declined') return '✕ Not selected';
    return '⏳ Pending review';
  };

  const cardStyle = (status) => {
    if (status === 'approved') return { ...s.card, ...s.cardApproved };
    if (status === 'declined') return { ...s.card, ...s.cardDeclined };
    return { ...s.card, ...s.cardPending };
  };

  return (
    <div style={s.page}>
      {lightbox && (
        <Lightbox photos={lightbox.photos} startIndex={lightbox.index} onClose={() => setLightbox(null)} />
      )}

      {confirmId && (
        <div style={s.confirmOverlay}>
          <div style={s.confirmBox}>
            <div style={s.confirmTitle}>Remove this moment?</div>
            <div style={s.confirmText}>
              It will be removed from your list. Our team will still be able to see it on the admin side.
            </div>
            <div style={s.confirmBtns}>
              <button style={s.confirmDelete} onClick={() => handleDelete(confirmId)}>Yes, remove it</button>
              <button style={s.confirmCancel} onClick={() => setConfirmId(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <h1 style={s.heading}>My Moments</h1>
      <p style={s.sub}>Your submitted moments and their status</p>

      {mine.length === 0 ? (
        <div style={s.empty}>
          <div style={s.emptyIcon}>📷</div>
          <div>You haven't submitted any moments yet</div>
        </div>
      ) : (
        mine.map(sub => (
          <div key={sub.id} style={cardStyle(sub.status)}>
            {winner === sub.id && (
              <div style={s.winnerBadge}>🏆 This month's winner!</div>
            )}
            <div style={s.topRow}>
              <div style={s.about}>{sub.about}</div>
              <span style={statusStyle(sub.status)}>{statusLabel(sub.status)}</span>
            </div>
            <div style={s.meta}>{sub.category} · {sub.shift} shift · {sub.submittedAt}</div>
            <div style={s.caption}>{sub.caption}</div>

            {sub.status === 'declined' && sub.declineReason && (
              <div style={s.declineReason}>
                <strong>Feedback:</strong> {sub.declineReason}
              </div>
            )}

            {Array.isArray(sub.photos) && sub.photos.length > 0 && (
              <div style={s.photoStrip}>
                {sub.photos.map((p, i) => (
                  <img
                    key={i}
                    src={p.url}
                    alt=""
                    style={s.photoThumb}
                    onClick={() => setLightbox({ photos: sub.photos, index: i })}
                    title="Tap to view full size"
                  />
                ))}
              </div>
            )}

            {sub.status === 'pending' && editingId === sub.id && (
              <EditableCard sub={sub} onSaved={() => setEditingId(null)} />
            )}

            <div style={s.bottomRow}>
              <span style={s.catBadge}>{sub.category}</span>
              <div style={{ display: 'flex', gap: '8px' }}>
                {sub.status === 'pending' && (() => {
                  const ageMin = Math.floor((Date.now() - new Date(sub.submittedAt.replace(' ', 'T') + '+00:00').getTime()) / 60000);
                  return ageMin < 30 ? (
                    <button style={s.editBtn} onClick={() => setEditingId(editingId === sub.id ? null : sub.id)}>
                      {editingId === sub.id ? 'Cancel' : 'Edit'}
                    </button>
                  ) : null;
                })()}
                <button style={s.deleteBtn} onClick={() => setConfirmId(sub.id)}>Remove</button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
